// reset store
export const RESET_STORE = "RESET_STORE";

// ----------- Auth ----------- //
export const AUTH_LOGIN_START = "AUTH_LOGIN_START";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";

// Auth Check
export const AUTH_CHECK = "AUTH_CHECK";

// Sign In Confirm
export const AUTH_SIGNIN_CONFIRM_START = "AUTH_SIGNIN_CONFIRM_START";
export const AUTH_SIGNIN_CONFIRM_SUCCESS = "AUTH_SIGNIN_CONFIRM_SUCCESS";
export const AUTH_SIGNIN_CONFIRM_FAIL = "AUTH_SIGNIN_CONFIRM_FAIL";

// Sign Up Confirm
export const AUTH_SIGN_UP_CONFIRM_START = "AUTH_SIGN_UP_CONFIRM_START";
export const AUTH_SIGN_UP_CONFIRM_SUCCESS = "AUTH_SIGN_UP_CONFIRM_SUCCESS";
export const AUTH_SIGN_UP_CONFIRM_FAIL = "AUTH_SIGN_UP_CONFIRM_FAIL";

// term conditions
export const AUTH_TERMS_CONDITIONS_START = "AUTH_TERMS_CONDITIONS_START";
export const AUTH_TERMS_CONDITIONS_FINISH = "AUTH_TERMS_CONDITIONS_FINISH";

// privacy policy
export const AUTH_PRIVACY_POLICY_START = "AUTH_PRIVACY_POLICY_START";
export const AUTH_PRIVACY_POLICY_FINISH = "AUTH_PRIVACY_POLICY_FINISH";

// Support Info
export const GET_SUPPORT_INFO_START = "GET_SUPPORT_INFO_START";
export const GET_SUPPORT_INFO_FINISH = "GET_SUPPORT_INFO_FINISH";

// Register
export const AUTH_REGISTER_START = "AUTH_REGISTER_START";
export const AUTH_REGISTER_SUCCESS = "AUTH_REGISTER_SUCCESS";
export const AUTH_REGISTER_FAIL = "AUTH_REGISTER_FAIL";

// Logout
export const AUTH_LOGOUT = "AUTH_LOGOUT";

// Resend OTP
export const RESEND_OTP_START = "RESEND_OTP_START";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_FAIL = "RESEND_OTP_FAIL";

// ----------- Language ----------- //
export const GET_LANGUAGES_START = "GET_LANGUAGES_START";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_FAIL = "GET_LANGUAGES_FAIL";
export const SET_LANGUAGES_FAIL = "SET_LANGUAGES_FAIL";

// ----------- Profile ----------- //
export const GET_USER_PROFILE_START = "GET_USER_PROFILE_START";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL";

// Get Profile Image
export const GET_PROFILE_IMAGE_START = "GET_PROFILE_IMAGE_START";
export const GET_PROFILE_IMAGE_SUCCESS = "GET_PROFILE_IMAGE_SUCCESS";
export const GET_PROFILE_IMAGE_FAIL = "GET_PROFILE_IMAGE_FAIL";

// Upload Profile Picture
export const UPLOAD_PROFILE_IMAGE_START = "UPLOAD_PROFILE_IMAGE_START";
export const UPLOAD_PROFILE_IMAGE_SUCCESS = "UPLOAD_PROFILE_IMAGE_SUCCESS";
export const UPLOAD_PROFILE_IMAGE_FAIL = "UPLOAD_PROFILE_IMAGE_FAIL";

// update Profile Data
export const UPDATE_PROFILE_DATA_START = "UPDATE_PROFILE_DATA_START";
export const UPDATE_PROFILE_DATA_SUCCESS = "UPDATE_PROFILE_DATA_SUCCESS";
export const UPDATE_PROFILE_DATA_FAIL = "UPDATE_PROFILE_DATA_FAIL";

// Get Category
export const GET_CATEGORY_START = "GET_CATEGORY_START";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAIL = "GET_CATEGORY_FAIL";

// load category icon
export const LOAD_CATEGORY_ICON_START = "LOAD_CATEGORY_ICON_START";
export const LOAD_CATEGORY_ICON_SUCCESS = "LOAD_CATEGORY_ICON_SUCCESS";
export const LOAD_CATEGORY_ICON_FAIL = "LOAD_CATEGORY_ICON_FAIL";

// Get Sub-Category
export const GET_SUBCATEGORY_START = "GET_SUBCATEGORY_START";
export const GET_SUBCATEGORY_SUCCESS = "GET_SUBCATEGORY_SUCCESS";
export const GET_SUBCATEGORY_FAIL = "GET_SUBCATEGORY_FAIL";

// Get Subscription Categories
export const GET_SUBSCRIPTION_CATEGORY_START = "GET_SUBSCRIPTION_CATEGORY_START";
export const GET_SUBSCRIPTION_CATEGORY_SUCCESS = "GET_SUBSCRIPTION_CATEGORY_SUCCESS";
export const GET_SUBSCRIPTION_CATEGORY_FAIL = "GET_SUBSCRIPTION_CATEGORY_FAIL";

// User message , notification count for header
export const HEADER_COUNT_START = "HEADER_COUNT_START";
export const HEADER_COUNT_SUCCESS = "HEADER_COUNT_SUCCESS";
export const HEADER_COUNT_FAIL = "HEADER_COUNT_FAIL";

// Toggle push notifications
export const TOGGLE_PUSH_NOTIFICATIONS_START = "TOGGLE_PUSH_NOTIFICATIONS_START";
export const TOGGLE_PUSH_NOTIFICATIONS_SUCCESS = "TOGGLE_PUSH_NOTIFICATIONS_SUCCESS";
export const TOGGLE_PUSH_NOTIFICATIONS_FAIL = "TOGGLE_PUSH_NOTIFICATIONS_FAIL";

// Get other users profile Image
export const GET_OTHER_USERS_PROFILE_IMAGE_START = "GET_OTHER_USERS_PROFILE_IMAGE_START";
export const GET_OTHER_USERS_PROFILE_IMAGE_SUCCESS = "GET_OTHER_USERS_PROFILE_IMAGE_SUCCESS";
export const GET_OTHER_USERS_PROFILE_IMAGE_FAIL = "GET_OTHER_USERS_PROFILE_IMAGE_FAIL";

// ----------- Subscription ----------- //

export const CANCEL_SUBSCRIPTION_START = "CANCEL_SUBSCRIPTION_START";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_FAIL = "CANCEL_SUBSCRIPTION_FAIL";

export const SUBSCRIPTION_START = "SUBSCRIPTION_START";
export const SUBSCRIPTION_SUCCESS = "SUBSCRIPTION_SUCCESS";
export const SUBSCRIPTION_FAIL = "SUBSCRIPTION_FAIL";

export const VERIFY_SUBSCRIPTION_SUCCESS = "VERIFY_SUBSCRIPTION_SUCCESS";

export const SUBSCRIPTION_PLAN_DETAILS_START = "SUBSCRIPTION_PLAN_DETAILS_START";
export const SUBSCRIPTION_PLAN_DETAILS_SUCCESS = "SUBSCRIPTION_PLAN_DETAILS_SUCCESS";
export const SUBSCRIPTION_PLAN_DETAILS_FAIL = "SUBSCRIPTION_PLAN_DETAILS_FAIL";

export const SUBSCRIPTION_SMS_DETAILS_START = "SUBSCRIPTION_SMS_DETAILS_START";
export const SUBSCRIPTION_SMS_DETAILS_SUCCESS = "SUBSCRIPTION_SMS_DETAILS_SUCCESS";
export const SUBSCRIPTION_SMS_DETAILS_FAIL = "SUBSCRIPTION_SMS_DETAILS_FAIL";

export const SUBSCRIBE_CATEGORIES_START = "SUBSCRIBE_CATEGORIES_START";
export const SUBSCRIBE_CATEGORIES_SUCCESS = "SUBSCRIBE_CATEGORIES_SUCCESS";
export const SUBSCRIBE_CATEGORIES_FAIL = "SUBSCRIBE_CATEGORIES_FAIL";

export const VERIFY_TELEBIRR_UN_SUBSCRIPTION_SUCCESS = "VERIFY_TELEBIRR_UN_SUBSCRIPTION_SUCCESS";
// ----------- Chats ----------- //

export const ALL_CONVERSATIONS_START = "ALL_CONVERSATIONS_START";
export const ALL_CONVERSATIONS_SUCCESS = "ALL_CONVERSATIONS_SUCCESS";
export const ALL_CONVERSATIONS_FAIL = "ALL_CONVERSATIONS_FAIL";
export const CURRENT_CONVERSATIONS_START = "CURRENT_CONVERSATIONS_START";
export const CURRENT_CONVERSATIONS_SUCCESS = "CURRENT_CONVERSATIONS_SUCCESS";
export const UPDATE_CURRENT_CONVERSATION_ID = "SEND_MESSAGE_FAIL";
export const UPDATE_CURRENT_CONVERSATION_ADVERT_ID =
  "UPDATE_CURRENT_CONVERSATION_ADVERT_ID";
export const CURRENT_CONVERSATIONS_FAIL = "CURRENT_CONVERSATIONS_FAIL";
export const SET_CURRENT_CONVERSATIONS = "SET_CURRENT_CONVERSATIONS";
export const DELETE_CONVERSATIONS_START = "DELETE_CONVERSATIONS_START";
export const DELETE_CONVERSATIONS_SUCCESS = "DELETE_CONVERSATIONS_SUCCESS";
export const DELETE_CONVERSATIONS_FAIL = "DELETE_CONVERSATIONS_FAIL";
export const SEND_MESSAGE_START = "SEND_MESSAGE_START";
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAIL = "SEND_MESSAGE_FAIL";
export const GET_CHAT_FILE_START = "GET_CHAT_FILE_START";
export const GET_CHAT_FILE_SUCCESS = "GET_CHAT_FILE_SUCCESS";
export const GET_CHAT_FILE_FAIL = "GET_CHAT_FILE_FAIL";
export const SET_MESSAGE_ID = "SET_MESSAGE_ID";
export const CLEAR_MESSAGE_ID = "CLEAR_MESSAGE_ID";

// ----------- Products ----------- //

// Add Product
export const ADD_PRODUCT_START = "ADD_PRODUCT_START";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAIL = "ADD_PRODUCT_FAIL";

// Get Seller Products
export const GET_SELLER_PRODUCT_START = "GET_SELLER_PRODUCT_START";
export const GET_SELLER_PRODUCT_SUCCESS = "GET_SELLER_PRODUCT_SUCCESS";
export const GET_SELLER_PRODUCT_FAIL = "GET_SELLER_PRODUCT_FAIL";

// Get Seller Products Images
export const GET_SINGLE_PRODUCT_IMAGES_START = "GET_SINGLE_PRODUCT_IMAGES_START";
export const GET_SINGLE_PRODUCT_IMAGES_SUCCESS = "GET_SINGLE_PRODUCT_IMAGES_SUCCESS";
export const GET_SINGLE_PRODUCT_IMAGES_FAIL = "GET_SINGLE_PRODUCT_IMAGES_FAIL";

// Get Seller Products Details By ID
export const GET_PRODUCT_DETAILS_START = "GET_PRODUCT_DETAILS_START";
export const GET_PRODUCT_DETAILS_SUCCESS = "GET_PRODUCT_DETAILS_SUCCESS";
export const GET_PRODUCT_DETAILS_FAIL = "GET_PRODUCT_DETAILS_FAIL";

// Get Buyer Products
export const GET_BUYER_PRODUCT_START = "GET_BUYER_PRODUCT_START";
export const GET_BUYER_PRODUCT_SUCCESS = "GET_BUYER_PRODUCT_SUCCESS";
export const GET_BUYER_PRODUCT_FAIL = "GET_BUYER_PRODUCT_FAIL";

// Get Products Image
export const GET_PRODUCT_IMAGE_START = "GET_PRODUCT_IMAGE_START";
export const GET_PRODUCT_IMAGE_SUCCESS = "GET_PRODUCT_IMAGE_SUCCESS";
export const GET_PRODUCT_IMAGE_FAIL = "GET_PRODUCT_IMAGE_FAIL";

// Product Preview
export const ADD_PRODUCT_PREVIEW_START = "ADD_PRODUCT_PREVIEW_START";
export const ADD_PRODUCT_PREVIEW = "ADD_PRODUCT_PREVIEW";
export const ADD_PRODUCT_PREVIEW_IMAGES_START = "ADD_PRODUCT_PREVIEW_IMAGES_START";
export const ADD_PRODUCT_PREVIEW_IMAGES = "ADD_PRODUCT_PREVIEW_IMAGES";

// Product Details
export const ADD_PRODUCT_DETAILS = "ADD_PRODUCT_DETAILS";

// new Product
export const GET_NEW_PRODUCT_START = "GET_NEW_PRODUCT_START";
export const GET_NEW_PRODUCT_SUCCESS = "GET_NEW_PRODUCT_SUCCESS";
export const GET_NEW_PRODUCT_FAIL = "GET_NEW_PRODUCT_FAIL";

// best seller product
export const GET_BEST_SELLER_PRODUCT_START = "GET_BEST_SELLER_PRODUCT_START";
export const GET_BEST_SELLER_PRODUCT_SUCCESS = "GET_BEST_SELLER_PRODUCT_SUCCESS";
export const GET_BEST_SELLER_PRODUCT_FAIL = "GET_BEST_SELLER_PRODUCT_FAIL";

// Delete Product
export const DELETE_PRODUCT_START = "DELETE_PRODUCT_START";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";

// Edit Product
export const EDIT_PRODUCT_START = "EDIT_PRODUCT_START";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAIL = "EDIT_PRODUCT_FAIL";

// More product from seller
export const GET_MORE_PRODUCT_FROM_SELLER_START = "GET_MORE_PRODUCT_FROM_SELLER_START";
export const GET_MORE_PRODUCT_FROM_SELLER_SUCCESS = "GET_MORE_PRODUCT_FROM_SELLER_SUCCESS";
export const GET_MORE_PRODUCT_FROM_SELLER_FAIL = "GET_MORE_PRODUCT_FROM_SELLER_FAIL";

// Deleted Images 
export const ADD_TO_DELETED_IMAGES = "ADD_TO_DELETED_IMAGES";
export const CLEAR_DELETED_IMAGES = "CLEAR_DELETED_IMAGES";

// Uploaded Images 
export const ADD_TO_UPLOADED_IMAGES = "ADD_TO_UPLOADED_IMAGES";
export const CLEAR_UPLOADED_IMAGES = "CLEAR_UPLOADED_IMAGES";

// Get advert Images using Advert Id
export const GET_IMAGE_FROM_ADVERTID_START = "GET_IMAGE_FROM_ADVERTID_START";
export const GET_IMAGE_FROM_ADVERTID_SUCCESS = "GET_IMAGE_FROM_ADVERTID_SUCCESS";
export const GET_IMAGE_FROM_ADVERTID_FAIL = "GET_IMAGE_FROM_ADVERTID_FAIL";

// Republish Product
export const REPUBLISH_PRODUCT_START = "REPUBLISH_PRODUCT_START";
export const REPUBLISH_PRODUCT_SUCCESS = "REPUBLISH_PRODUCT_SUCCESS";
export const REPUBLISH_PRODUCT_FAIL = "REPUBLISH_PRODUCT_FAIL";

// Add Review
export const ADD_REVIEW_START = "ADD_REVIEW_START";
export const ADD_REVIEW_SUCCESS = "ADD_REVIEW_SUCCESS";
export const ADD_REVIEW_FAIL = "ADD_REVIEW_FAIL";

// ----------- Location ----------- //
export const GET_LOCATION_START = "GET_LOCATION_START";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_FAIL = "GET_LOCATION_FAIL";

// ----------- Notification ----------- //
export const GET_NOTIFICATION_START = "GET_NOTIFICATION_START";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL";

export const DELETE_NOTIFICATION_START = "DELETE_NOTIFICATION_START";
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_FAIL = "DELETE_NOTIFICATION_FAIL";

// ----------- Header ----------- //
export const OPEN_HEADER_MENU = "OPEN_HEADER_MENU";
export const CLOSE_HEADER_MENU = "CLOSE_HEADER_MENU";
export const OPEN_NOTIFICATION_MENU = "OPEN_NOTIFICATION_MENU";
export const CLOSE_NOTIFICATION_MENU = "CLOSE_NOTIFICATION_MENU";
export const OPEN_LOGOUT_MODAL = "OPEN_LOGOUT_MODAL";
export const CLOSE_LOGOUT_MODAL = "CLOSE_LOGOUT_MODAL";
export const OPEN_ITEM_UNDER_REVIEW_MODAL = "OPEN_ITEM_UNDER_REVIEW_MODAL";
export const CLOSE_ITEM_UNDER_REVIEW_MODAL = "CLOSE_ITEM_UNDER_REVIEW_MODAL";
export const TERMS_CONDITIONS_MODAL = "TERMS_CONDITIONS_MODAL";
export const OPEN_DELETE_NOTIFICATION_MODAL = "OPEN_DELETE_NOTIFICATION_MODAL";
export const CLOSE_DELETE_NOTIFICATION_MODAL = "CLOSE_DELETE_NOTIFICATION_MODAL";
export const OPEN_DELETE_ADVERT_MODAL = "OPEN_DELETE_ADVERT_MODAL";
export const CLOSE_DELETE_ADVERT_MODAL = "CLOSE_DELETE_ADVERT_MODAL";
export const OPEN_DELETE_CHAT_MODAL = "OPEN_DELETE_CHAT_MODAL";
export const CLOSE_DELETE_CHAT_MODAL = "CLOSE_DELETE_CHAT_MODAL";
export const OPEN_REPUBLISH_ADVERT_MODAL = "OPEN_REPUBLISH_ADVERT_MODAL";
export const CLOSE_REPUBLISH_ADVERT_MODAL = "CLOSE_REPUBLISH_ADVERT_MODAL";
export const PRIVACY_POLICY_MODAL = "PRIVACY_POLICY_MODAL";
export const OPEN_SWITCH_USER_TYPE_MODAL = "OPEN_SWITCH_USER_TYPE_MODAL";
export const CLOSE_SWITCH_USER_TYPE_MODAL = "CLOSE_SWITCH_USER_TYPE_MODAL";
export const OPEN_DELETE_ACCOUNT_MODAL = "OPEN_DELETE_ACCOUNT_MODAL";
export const CLOSE_DELETE_ACCOUNT_MODAL = "CLOSE_DELETE_ACCOUNT_MODAL";
export const TOGGLE_PROVIDER_SERVICE_MODAL = "TOGGLE_PROVIDER_SERVICE_MODAL";
export const UPDATE_DATA_IN_PROVIDER_SERVICE_MODAL = "UPDATE_DATA_IN_PROVIDER_SERVICE_MODAL";
export const SET_CHANGE_PROFILE_TYPE = "SET_CHANGE_PROFILE_TYPE";

// ----------- Favorites ----------- //

// Add Product to favorite
export const ADD_PRODUCT_FAVORITE_START = "ADD_PRODUCT_FAVORITE_START";
export const ADD_PRODUCT_FAVORITE_SUCCESS = "ADD_PRODUCT_FAVORITE_SUCCESS";
export const ADD_PRODUCT_FAVORITE_FAIL = "ADD_PRODUCT_FAVORITE_FAIL";

// Remove Product to favorite
export const REMOVE_PRODUCT_FAVORITE_START = "REMOVE_PRODUCT_FAVORITE_START";
export const REMOVE_PRODUCT_FAVORITE_SUCCESS = "REMOVE_PRODUCT_FAVORITE_SUCCESS";
export const REMOVE_PRODUCT_FAVORITE_FAIL = "REMOVE_PRODUCT_FAVORITE_FAIL";

// get favorite products
export const GET_FAVORITE_PRODUCTS_START = "GET_FAVORITE_PRODUCTS_START";
export const GET_FAVORITE_PRODUCTS_SUCCESS = "GET_FAVORITE_PRODUCTS_SUCCESS";
export const GET_FAVORITE_PRODUCTS_FAIL = "GET_FAVORITE_PRODUCTS_FAIL";

// ----------- Favorites ----------- //

// Filter By Price
export const FILTER_BY_PRICE_START = "FILTER_BY_PRICE_START";
export const FILTER_BY_PRICE_SUCCESS = "FILTER_BY_PRICE_SUCCESS";
export const FILTER_BY_PRICE_FAIL = "FILTER_BY_PRICE_FAIL";

// Filter by sorting
export const FILTER_BY_SORTING_START = "FILTER_BY_SORTING_START";
export const FILTER_BY_SORTING_SUCCESS = "FILTER_BY_SORTING_SUCCESS";
export const FILTER_BY_SORTING_FAIL = "FILTER_BY_SORTING_FAIL";

// Search text 
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";

// Initialize Password Reset
export const INIT_PASSWORD_RESET_START = "INIT_PASSWORD_RESET_START";
export const INIT_PASSWORD_RESET_SUCCESS = "INIT_PASSWORD_RESET_SUCCESS";
export const INIT_PASSWORD_RESET_FAIL = "INIT_PASSWORD_RESET_FAIL";

// Reset Password
export const RESET_PASSWORD_START = "RESET_PASSWORD_START";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

// ----------- swith user type ----------- //
export const SWITCH_USER_TYPE_START = "SWITCH_USER_TYPE_START";
export const SWITCH_USER_TYPE_SUCCESS = "SWITCH_USER_TYPE_SUCCESS";
export const SWITCH_USER_TYPE_FAIL = "SWITCH_USER_TYPE_FAIL";

// ----------- Delete Account ----------- //
export const DELETE_ACCOUNT_START = "DELETE_ACCOUNT_START";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_FAIL = "DELETE_ACCOUNT_FAIL";

// ----------- Get Product feedbacks By Advert ID ----------- //
export const GET_PRODUCT_FEEDBACKS_START = "GET_PRODUCT_FEEDBACKS_START";
export const GET_PRODUCT_FEEDBACKS_SUCCESS = "GET_PRODUCT_FEEDBACKS_SUCCESS";
export const GET_PRODUCT_FEEDBACKS_FAIL = "GET_PRODUCT_FEEDBACKS_FAIL";

// ----------- Get Product feedback Summary By Advert ID ----------- //
export const GET_PRODUCT_FEEDBACK_SUMMARY_START = "GET_PRODUCT_FEEDBACK_SUMMARY_START";
export const GET_PRODUCT_FEEDBACK_SUMMARY_SUCCESS = "GET_PRODUCT_FEEDBACK_SUMMARY_SUCCESS";
export const GET_PRODUCT_FEEDBACK_SUMMARY_FAIL = "GET_PRODUCT_FEEDBACK_SUMMARY_FAIL";

// ----------- Service Provider ----------- //
// Get Provider Categories
export const GET_PROVIDER_CATEGORY_START = "GET_PROVIDER_CATEGORY_START";
export const GET_PROVIDER_CATEGORY_SUCCESS = "GET_PROVIDER_CATEGORY_SUCCESS";
export const GET_PROVIDER_CATEGORY_FAIL = "GET_PROVIDER_CATEGORY_FAIL";

// Get Provider Category Icons
export const GET_PROVIDER_CATEGORY_ICONS_START = "GET_PROVIDER_CATEGORY_ICONS_START";
export const GET_PROVIDER_CATEGORY_ICONS_SUCCESS = "GET_PROVIDER_CATEGORY_ICONS_SUCCESS";
export const GET_PROVIDER_CATEGORY_ICONS_FAIL = "GET_PROVIDER_CATEGORY_ICONS_FAIL";

// Get Provider Subcategory
export const GET_PROVIDER_SUBCATEGORY_START = "GET_PROVIDER_SUBCATEGORY_START";
export const GET_PROVIDER_SUBCATEGORY_SUCCESS = "GET_PROVIDER_SUBCATEGORY_SUCCESS";
export const GET_PROVIDER_SUBCATEGORY_FAIL = "GET_PROVIDER_SUBCATEGORY_FAIL";

// Get Service Providers
export const GET_SERVICE_PROVIDERS_START = "GET_SERVICE_PROVIDERS_START";
export const GET_SERVICE_PROVIDERS_SUCCESS = "GET_SERVICE_PROVIDERS_SUCCESS";
export const GET_SERVICE_PROVIDERS_FAIL = "GET_SERVICE_PROVIDERS_FAIL";

// get service provider details
export const GET_SERVICE_PROVIDER_DETAILS_START = "GET_SERVICE_PROVIDER_DETAILS_START";
export const GET_SERVICE_PROVIDER_DETAILS_SUCCESS = "GET_SERVICE_PROVIDER_DETAILS_SUCCESS";
export const GET_SERVICE_PROVIDER_DETAILS_FAIL = "GET_SERVICE_PROVIDER_DETAILS_FAIL";

// Get Provider Files
export const GET_PROVIDER_FILES_START = "GET_PROVIDER_FILES_START";
export const GET_PROVIDER_FILES_SUCCESS = "GET_PROVIDER_FILES_SUCCESS";
export const GET_PROVIDER_FILES_FAIL = "GET_PROVIDER_FILES_FAIL";

// provider terms and condition
export const PROVIDER_TERMS_CONDITIONS_MODAL = "PROVIDER_TERMS_CONDITIONS_MODAL";
export const PROVIDER_TERMS_CONDITIONS_START = "PROVIDER_TERMS_CONDITIONS_START";
export const PROVIDER_TERMS_CONDITIONS_FINISH = "PROVIDER_TERMS_CONDITIONS_FINISH";

// provide terms and condition status
export const GET_PROVIDER_TNC_STATUS_START = "GET_PROVIDER_TNC_STATUS_START";
export const GET_PROVIDER_TNC_STATUS_SUCCESS = "GET_PROVIDER_TNC_STATUS_SUCCESS";
export const GET_PROVIDER_TNC_STATUS_FAIL = "GET_PROVIDER_TNC_STATUS_FAIL";

// accept provider terms and condition
export const ACCEPT_PROVIDER_TERMS_AND_CONDITION_START = "ACCEPT_PROVIDER_TERMS_AND_CONDITION_START";
export const ACCEPT_PROVIDER_TERMS_AND_CONDITION_SUCCESS = "ACCEPT_PROVIDER_TERMS_AND_CONDITION_SUCCESS";
export const ACCEPT_PROVIDER_TERMS_AND_CONDITION_FAIL = "ACCEPT_PROVIDER_TERMS_AND_CONDITION_FAIL";

// user image from user id
export const GET_USER_IMAGE_FROM_ID_START = "GET_USER_IMAGE_FROM_ID_START";
export const GET_USER_IMAGE_FROM_ID_SUCCESS = "GET_USER_IMAGE_FROM_ID_SUCCESS";
export const GET_USER_IMAGE_FROM_ID_FAIL = "GET_USER_IMAGE_FROM_ID_FAIL";
